import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAdminSetting = () => {
  return Api(endPoints.getSetting, null, requestType.GET);
};

const updateAdminSetting = (id, params) => {
  return Api(`${endPoints.updateSetting}/${id}`, params, requestType.PUT);
};

export { getAdminSetting, updateAdminSetting };
